import { render, staticRenderFns } from "./DefaultMenu.vue?vue&type=template&id=3c17aca0&"
import script from "./DefaultMenu.vue?vue&type=script&lang=js&"
export * from "./DefaultMenu.vue?vue&type=script&lang=js&"
import style0 from "./DefaultMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports